/* eslint-disable no-restricted-syntax */
export default {
  isEmpty(obj) {
    if (!Object.keys(obj)) {
      for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          return false;
        }
      }
    } else {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    }
    return JSON.stringify(obj) === JSON.stringify({});
  },
};



// WEBPACK FOOTER //
// ./src/services/UtilsService.js